import { forwardRef } from "react";
import { PartnerTile } from "./PartnerTile";
import type { PartnerView } from "./partnerList";

export const PartnerMarqueeRow = forwardRef<
  HTMLDivElement,
  {
    items: PartnerView[];
    duration: number;
    reverse?: boolean;
    paused: boolean;
    linkLabel: (name: string) => string;
  }
>(function PartnerMarqueeRow({ items, duration, reverse = false, paused, linkLabel }, ref) {
  return (
    <div ref={ref} className="partner-row partner-viewport">
      <div
        className="partner-track"
        data-paused={paused ? "true" : "false"}
        data-reverse={reverse ? "true" : "false"}
        style={{ ["--partner-duration" as string]: `${duration}s` }}
      >
        <div className="partner-copy">
          {items.map((partner, index) => (
            <div key={`${partner.id}-${index}`} className="partner-slot shrink-0 pr-4">
              <PartnerTile partner={partner} linkLabel={linkLabel(partner.name)} />
            </div>
          ))}
        </div>
        <div className="partner-copy" data-clone="true" aria-hidden="true" inert>
          {items.map((partner, index) => (
            <div key={`clone-${partner.id}-${index}`} className="partner-slot shrink-0 pr-4">
              <PartnerTile partner={partner} linkLabel={linkLabel(partner.name)} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});
